import * as React from "react"
import { LogoSkeleton, LogoProps } from "./skeleton"

export function PrismicLogo(props: LogoProps) {
  return (
    <LogoSkeleton {...props} logoName="PrismicLogo">
      <path
        d="M6.48145 3.19531H5.57458C4.24814 3.19531 3.17358 4.27012 3.17358 5.59596V12.6904C4.0369 13.2184 4.99337 13.4647 5.75747 13.5779C5.6504 13.363 5.59019 13.1214 5.59019 12.8668V7.21597C5.59019 7.21426 5.59019 7.21254 5.5902 7.21082C5.58989 7.1172 5.59313 5.00651 6.48145 3.19531Z"
        fill="#CA67CC"
      />
      <path
        d="M16.8601 6.50307V5.59623C16.8601 4.26983 15.7853 3.19531 14.4594 3.19531L7.36466 3.19531C6.83667 4.0586 6.59039 5.01503 6.47719 5.77911C6.69207 5.67204 6.93373 5.61183 7.18833 5.61183H12.8393C12.841 5.61183 12.8427 5.61183 12.8445 5.61184C12.9381 5.61154 15.0489 5.61477 16.8601 6.50307Z"
        fill="#EA5E49"
      />
      <path
        d="M13.4985 16.8594H14.4054C15.7318 16.8594 16.8064 15.7846 16.8064 14.4587V7.36425C15.9431 6.83629 14.9866 6.59002 14.2225 6.47682C14.3296 6.69168 14.3898 6.93334 14.3898 7.18793L14.3898 12.8387C14.3898 12.8404 14.3898 12.8421 14.3898 12.8439C14.3901 12.9375 14.3869 15.0482 13.4985 16.8594Z"
        fill="#FFBF57"
      />
      <path
        d="M3.13013 13.4979L3.13013 14.4047C3.13013 15.7311 4.20497 16.8057 5.53086 16.8057L12.6256 16.8057C13.1536 15.9424 13.3998 14.9859 13.513 14.2219C13.2982 14.3289 13.0565 14.3891 12.8019 14.3891L7.15093 14.3891C7.14921 14.3891 7.14749 14.3891 7.14578 14.3891C7.05215 14.3894 4.94138 14.3862 3.13013 13.4979Z"
        fill="#699FF1"
      />
      <path
        d="M11.0669 0H4.81537C2.16431 0 0.00848357 2.14737 0 4.79952L0.00742517 4.7993C0.00742517 4.7993 0.207195 9.3986 2.00512 11.5983C2.12955 11.7505 2.26162 11.8912 2.3997 12.0213V5.60412C2.3997 3.83434 3.82952 2.39964 5.60429 2.39964H6.95653C7.18602 2.07623 7.45431 1.77773 7.76795 1.52139C8.59042 0.84918 9.83316 0.355137 11.0669 0Z"
        fill="#CA67CC"
      />
      <path
        d="M19.999 11.0665V4.81521C19.999 2.16424 17.8516 0.00848325 15.1993 0L15.1996 0.0074249C15.1996 0.0074249 10.6001 0.207188 8.40035 2.00505C8.24812 2.12947 8.10739 2.26155 7.97728 2.39962L14.3947 2.39962C16.1646 2.39962 17.5993 3.82938 17.5993 5.6041V6.95629C17.9227 7.18577 18.2212 7.45405 18.4776 7.76768C19.1498 8.59012 19.6439 9.83282 19.999 11.0665Z"
        fill="#EA5E49"
      />
      <path
        d="M8.9338 19.998H15.1854C17.8364 19.998 19.9922 17.8507 20.0007 15.1985L19.9933 15.1988C19.9933 15.1988 19.7935 10.5994 17.9956 8.39978C17.8712 8.24755 17.7391 8.10682 17.601 7.97672V14.3939C17.601 16.1637 16.1712 17.5984 14.3964 17.5984H13.0442C12.8147 17.9218 12.5464 18.2203 12.2328 18.4767C11.4103 19.1489 10.1676 19.6429 8.9338 19.998Z"
        fill="#FFBF57"
      />
      <path
        d="M0.0214844 8.93345L0.0214844 15.1848C0.0214844 17.8358 2.16893 19.9915 4.82117 20L4.82095 19.9926C4.82095 19.9926 9.42041 19.7928 11.6202 17.9949C11.7724 17.8705 11.9131 17.7385 12.0432 17.6004H5.6258C3.85595 17.6004 2.42121 16.1706 2.42121 14.3959L2.42121 13.0437C2.09778 12.8142 1.79928 12.5459 1.54292 12.2323C0.870694 11.4099 0.376633 10.1672 0.0214844 8.93345Z"
        fill="#699FF1"
      />
    </LogoSkeleton>
  )
}
